// extracted by mini-css-extract-plugin
module.exports = {"container":"SelectedProductPlaceholder_container__3U_kN"};